import React, { useEffect, useState } from 'react';
import {
  departureDateSelector,
  departureCitySelector,
  arrivalCitySelector,
  localeSelector,
  dateLabelSelector,
} from 'app/store/selectors';
import { StoreState } from 'app/models/types';
import { connect, useSelector } from 'react-redux';
import { useTranslations } from 'app/hooks/useTranslations';
import { CityDetailsResult, PartialSearchMaskLocation } from 'app/models/types/store/location';

type HeadUiProps = {
  departureCity: CityDetailsResult | PartialSearchMaskLocation;
  arrivalCity: CityDetailsResult | PartialSearchMaskLocation;
  departureDate: Date;
};
/**
 * HeadUi
 *
 * used to manipulate head elements dynamically
 * this should be rewritten to be a hook once dependencies are updated
 */
export const HeadUi: React.FC<HeadUiProps> = ({ departureCity, arrivalCity, departureDate }) => {
  // Self flag if title is in control of this component
  const [hasTitleControl, setHasTitleControl] = useState(false);
  const dateLabel = useSelector(dateLabelSelector);

  const { getPageTitle } = useTranslations({ getPageTitle: 'search_result_route_title' });

  useEffect(() => {
    if (departureCity && arrivalCity && !!getPageTitle && departureDate) {
      const date = dateLabel(departureDate);
      const title = getPageTitle({
        departure: departureCity.name,
        arrival: arrivalCity.name,
        date,
      });
      const titleTags = document.getElementsByTagName('title');
      if (
        !titleTags[0] ||
        titleTags[0].innerHTML.replace(/[ \n]/g, '').length === 0 ||
        hasTitleControl
      ) {
        document.title = title;
        // flag that it's this component that changed the title
        // this ensures title to be updated when data changes
        if (!hasTitleControl) setHasTitleControl(true);
      }
    }
  }, [departureCity, arrivalCity, getPageTitle, departureDate]);
  return null;
};

const mapStateToProps = (state: StoreState) => ({
  locale: localeSelector(state),
  departureDate: departureDateSelector(state),
  departureCity: departureCitySelector(state),
  arrivalCity: arrivalCitySelector(state),
});

export const Head = connect(mapStateToProps)(HeadUi);
